// src/pages/financeiro/AssinaturaPixPage.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import QRCode from 'qrcode';
import { FaCheck, FaRegCopy } from 'react-icons/fa';
import { buscarPixAssinatura } from '../../services/financeiro/AssinaturaService';

const AssinaturaPixPage = () => {
  const { token } = useParams();
  const [payloadPix, setPayloadPix] = useState('');
  const [dadosPix, setDadosPix] = useState(null);
  const [qrCode, setQrCode] = useState('');
  const [erro, setErro] = useState('');
  const [copiado, setCopiado] = useState(false);

  useEffect(() => {
    const gerarQrCode = async () => {
      try {
        const pix = await buscarPixAssinatura(token);
        const payload = typeof pix === 'string' ? pix : pix?.payload;

        if (!payload) {
          throw new Error('Payload Pix não retornado pela API.');
        }

        const dataUrl = await QRCode.toDataURL(payload, {
          width: 280,
          margin: 2,
        });

        setPayloadPix(payload);
        setDadosPix(typeof pix === 'string' ? null : pix);
        setQrCode(dataUrl);
      } catch (error) {
        console.error('Erro ao gerar QR Code Pix:', error);
        setErro('Não foi possível gerar o QR Code Pix.');
      }
    };

    if (token) {
      gerarQrCode();
    }
  }, [token]);

  const copiarPix = async () => {
    if (!payloadPix) return;

    await navigator.clipboard.writeText(payloadPix);
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2000);
  };

  const valorPix = dadosPix?.valor != null ? Number(dadosPix.valor) : null;
  const valorFormatado = Number.isFinite(valorPix) ? valorPix.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }) : '';

  return (
    <div
      className="login-container"
      style={{
        display: 'flex',
        width: '100%',
        height: '100dvh',
        minHeight: '100vh',
        alignItems: 'flex-start',
        justifyContent: 'center',
        overflowX: 'hidden',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        background: '#f8fbff',
        padding: '0px 0px 10px',
      }}
    >
      <div
        className="login-form"
        style={{
          width: '100%',
          maxWidth: 420,
          boxSizing: 'border-box',
          textAlign: 'center',
          border: 'none',
          borderRadius: 0,
          boxShadow: 'none',
          padding: '10px 12px 12px',
          background: 'transparent',
          color: '#17233c',
        }}
      >
        <h2 style={{ marginBottom: 6, fontWeight: 800, color: '#10233f' }}>Pagamento Pix</h2>
        <p style={{ marginBottom: 10, color: '#5b667a', fontSize: 15 }}>
          Escaneie o QR Code ou copie o código Pix.
        </p>
        {erro ? (
          <div className="alert alert-danger">{erro}</div>
        ) : qrCode ? (
          <>
            {(dadosPix?.recebedor || valorFormatado) && (
              <div
                className="mb-3"
                style={{
                  display: 'grid',
                  gap: 8,
                  padding: '12px 14px',
                  borderRadius: 12,
                  background: '#eef4f8',
                  color: '#26364f',
                  textAlign: 'center',
                }}
              >
                {dadosPix?.recebedor && (
                  <div>
                    <strong>Recebedor:</strong> {dadosPix.recebedor}
                  </div>
                )}
                {valorFormatado && (
                  <div>
                    <strong>Valor:</strong> {valorFormatado}
                  </div>
                )}
              </div>
            )}
            <div
              style={{
                display: 'inline-flex',
                maxWidth: '100%',
                padding: 0,
                borderRadius: 0,
                background: 'transparent',
                border: 'none',
                boxShadow: 'none',
              }}
            >
              <img
                src={qrCode}
                alt="QR Code Pix"
                style={{ width: 'min(280px, 100%)', height: 'auto' }}
              />
            </div>
            <textarea
              className="form-control mt-3"
              value={payloadPix}
              readOnly
              rows={3}
              style={{
                resize: 'none',
                textAlign: 'center',
                fontSize: 14,
                lineHeight: 1.55,
                border: 'none',
                borderRadius: 12,
                color: '#1d2c43',
                background: '#eef4f8',
                boxShadow: 'none',
              }}
            />
            <button
              type="button"
              className="btn mt-3"
              onClick={copiarPix}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 8,
                minWidth: 190,
                borderRadius: 10,
                border: 'none',
                background: copiado ? '#198754' : '#0d6efd',
                color: '#ffffff',
                fontWeight: 700,
                boxShadow: '0 10px 20px rgba(13, 110, 253, 0.22)',
              }}
            >
              {copiado ? <FaCheck /> : <FaRegCopy />}
              {copiado ? 'Código copiado' : 'Copiar código Pix'}
            </button>
          </>
        ) : (
          <div className="login-loading">
            <div className="spinner-border" role="status" style={{ color: '#3d6df2' }} />
            <strong className="login-loading-text">Gerando QR Code...</strong>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssinaturaPixPage;
